import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { SellLimitDialogForm } from '../SellLimitDialogForm';
import { DELETE_SELL_LIMIT_DIALOG_NAME } from '../../constants';
import { useDeleteSellLimitFormControls, useSellLimitOptions } from '../../hooks';
import { DeleteSellLimitFormFields } from './DeleteSellLimitFormFields';

type Props = WithServiceId & WithEnterpriseId;

export const DeleteSellLimitDialogForm = ({ enterpriseId, serviceId }: Props) => {
    const { isSubmitting, hasDirtyFields, renderFormContent, submit } = useDeleteSellLimitFormControls({
        serviceId,
    });

    const { isFetching, groupedRateOptions, rateGroupOptions, resourceCategoryOptions } = useSellLimitOptions({
        enterpriseId,
        serviceId,
    });

    return (
        <SellLimitDialogForm
            dialogName={DELETE_SELL_LIMIT_DIALOG_NAME}
            formTitle={TextKey.SellLimitsDeleteFormTitle}
            hasDirtyFields={hasDirtyFields}
            isLoading={isFetching || isSubmitting}
            submit={submit}
            submitLabel={TextKey.SellLimitsDeleteFormSubmitLabel}
        >
            {renderFormContent(
                <DeleteSellLimitFormFields
                    groupedRateOptions={groupedRateOptions}
                    rateGroupOptions={rateGroupOptions}
                    resourceCategoryOptions={resourceCategoryOptions}
                />
            )}
        </SellLimitDialogForm>
    );
};
